import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CoupanCityActions } from "stores/CoupanCitylistStore/CoupanCityAction";

const mapStateToProps = (state) => {
  return {
    CoupanCityList: state.CoupanCity.CoupanCityList,
    SelectCouponCityListdata: state.CoupanCity.SelectCouponCityListdata,
    SelectChargingNetworkListdata:
      state.CoupanCity.SelectChargingNetworkListdata,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCoupanCityActions: CoupanCityActions.getCoupanCityActions,
      postAddCoupanAction: CoupanCityActions.postAddCoupanModel,
      getSlectCouponCityAction: CoupanCityActions.getSlectCouponCity,

      getSelectChargingNetworkAction:
        CoupanCityActions.getSelectChargingNetwork,
    },
    dispatch
  );

const AddCouponStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default AddCouponStore;
